import { defineMessages } from 'react-intl';

export default defineMessages({
  authSnackbarConfirmationEmail: {
    defaultMessage: 'Confirmation e-mail was sent. Please check your e-mail box and follow the instructions.',
    description: 'Auth snackbar - Confirmation e-mail',
    id: 'authSnackbarConfirmationEmail',
  },
  registerAgreeLabel: {
    defaultMessage:
      'I agree with <linkcloud>My2N Cloud Agreement</linkcloud>' +
      ' and I have read <linkinfo>Information for Consumers</linkinfo>',
    description: 'Register - agree label',
    id: 'register.agree.label',
  },
  registerAgreeRequired: {
    defaultMessage: 'You must agree to the terms.',
    description: 'Register - agree required label',
    id: 'register.agree.required',
  },

  registerCompanyNameLabel: {
    defaultMessage: 'Company name / Family name',
    description: 'Register - company name label',
    id: 'register.companyName.label',
  },
  registerEmailInvalid: {
    defaultMessage: 'Wrong format of the e-mail.',
    description: 'Register - email invalid',
    id: 'register.email.invalid',
  },
  registerEmailLabel: {
    defaultMessage: 'Your e-mail',
    description: 'Register - email label',
    id: 'register.email.label',
  },
  registerEmailUsed: {
    defaultMessage: `This e-mail is already used. Please choose a different one or
        log in to your existing account.`,
    description: 'Register - email already used',
    id: 'register.email.used',
  },
  registerFirstNameLabel: {
    defaultMessage: 'First name',
    description: 'Register - first name label',
    id: 'register.firstName.label',
  },
  RegisterImsConfirm: {
    defaultMessage: 'Create account',
    id: 'register.ims.confirm',
  },
  RegisterImsSubtitle: {
    defaultMessage: 'Already have an account? <link>Log in</link>',
    id: 'register.ims.subtitle',
  },
  RegisterImsSuccessText: {
    defaultMessage: `Check your inbox or spam folder and follow the instructions.{br}
If you haven’t received the email, check the spelling of the address.`,
    id: 'register.ims.success.text',
  },
  RegisterImsSuccessTitle: {
    defaultMessage: 'Activation email sent to: <b>{email}</b>',
    id: 'register.ims.success.title',
  },
  RegisterImsTitle: {
    defaultMessage: `Create account to{br} manage My2N sites`,
    id: 'register.ims.title',
  },
  registerLastNameLabel: {
    defaultMessage: 'Surname',
    description: 'Register - surname label',
    id: 'register.lastName.label',
  },

  registerLoginText: {
    defaultMessage: 'Already have an account?',
    description: 'Register - Already have an account?',
    id: 'register.login.text',
  },

  registerPasswordLabel: {
    defaultMessage: 'Password',
    description: 'Register - password label',
    id: 'register.password.label',
  },
  registerReferrerLabel: {
    defaultMessage: 'Where did you find out about My2N?',
    description: 'Register - referrer label',
    id: 'register.referrer.label',
  },
  registerReferrerOptionsADVERTISEMENT: {
    defaultMessage: 'Internet advertisement',
    description: 'Register - Internet advertisement',
    id: 'register.referrer.options.ADVERTISEMENT',
  },
  registerReferrerOptionsARTICLE: {
    defaultMessage: 'Internet or print article',
    description: 'Register - Article',
    id: 'register.referrer.options.ARTICLE',
  },
  registerReferrerOptionsCONVENTION: {
    defaultMessage: 'At a convention',
    description: 'Register - At a convention',
    id: 'register.referrer.options.CONVENTION',
  },
  registerReferrerOptionsNEWSLETTER: {
    defaultMessage: 'Newsletter',
    description: 'Register - Newsletter',
    id: 'register.referrer.options.NEWSLETTER',
  },
  registerReferrerOptionsOTHER: {
    defaultMessage: 'Other',
    description: 'Register - Other',
    id: 'register.referrer.optionsOther',
  },
  registerReferrerOptionsPAPER_CARD: {
    defaultMessage: 'Paper card in product package',
    description: 'Register - Paper card in product package',
    id: 'register.referrer.options.PAPER_CARD',
  },
  registerReferrerOptionsPRODUCT_SELLER: {
    defaultMessage: 'From the seller of product',
    description: 'Register - From the seller of product',
    id: 'register.referrer.options.PRODUCT_SELLER',
  },

  registerReferrerOptionsSOCIAL_NETWORKS: {
    defaultMessage: 'Social networks',
    description: 'Register - Social networks',
    id: 'register.referrer.options.SOCIAL_NETWORKS',
  },

  registerRequired: {
    defaultMessage: 'Value is mandatory',
    description: 'Register - Value is mandatory',
    id: 'register.firstName.required',
  },
  registerUserCategoryLabel: {
    defaultMessage: 'What is your role?',
    id: 'register.userCategory.label',
  },
  registerUserCategoryOtherLabel: {
    defaultMessage: 'Please specify your role',
    id: 'register.userCategory.other.label',
  },
  SharedNotificationErrTryAgain: {
    defaultMessage: 'There was an error, please try again',
    id: 'shared.notification.ErrTryAgain',
  },
});
